module.exports = __webpack_public_path__ + "img/burger_menu.ee9fee86.svg";